import { Component, computed, ElementRef, inject, input, output } from '@angular/core';

const MAX_NOTIFICATION_COUNT = 99;

@Component({
  selector: 'f-icon-notification-button',
  templateUrl: './icon-notification-button.component.html',
  styleUrls: ['./icon-notification-button.component.scss'],
  standalone: false
})
export class FireflyIconNotificationButtonComponent {
  title = input<string>();
  notificationCount = input<number>(0);
  disabled = input(false);
  icon = input('f-i-bell');

  buttonClick = output<void>();

  private el = inject(ElementRef);

  get dataAutomationId(): string {
    return this.el.nativeElement.dataset.automationId || 'icon-notification-button';
  }

  readonly displayCount = computed<string | number>(() =>
    this.notificationCount() > MAX_NOTIFICATION_COUNT ? `${MAX_NOTIFICATION_COUNT}+` : this.notificationCount()
  );

  onButtonClick(): void {
    this.buttonClick.emit();
  }
}
